import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MaterialModule } from '../material.module';
import { PaginationComponent } from './components/pagination/pagination.component';
import { HeaderBoxComponent } from './components/header-box/header-box.component';
import { DisplayErrorsComponent } from './components/display-errors/display-errors.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { WizardFormComponent } from './components/wizard-form/wizard-form.component';
import { FloatingNumberInputComponent } from './components/floating-number-input/floating-number-input.component';
import { LineChartComponent } from './components/charts/line-chart/line-chart.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselModule } from '@jacobg213/primeng-17/carousel';
import { InputPagingBarComponent } from './components/input-paging-bar/input-paging-bar.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { ProjectOverviewLayoutComponent } from './components/project-overview-layout/project-overview-layout.component';
import { NewLineToBrPipe } from './pipes/new-line-to-br.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { ToastMessageContainerComponent } from './components/toast-message-container/toast-message-container.component';
import {
    NgbPaginationModule,
    NgbToastModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from './components/confirmation-modal/confirmation-dialog.component';
import { AlgorithmInputComponent } from './components/algorithm-input/algorithm-input.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ContainerImageUploadComponent } from './components/container-administration/container-settings/container-image-upload/container-image-upload.component';
import { ContainerCollaborationSettingsComponent } from './components/container-collaboration-settings/container-collaboration-settings.component';

import { SettingsComponent } from './components/container-administration/container-settings/settings.component';
import { ContainerMembersComponent } from './components/container-administration/container-members/container-members.component';
import { SimpleTrybPaginationComponent } from './components/simple-tryb-pagination/simple-tryb-pagination.component';
import { ImageUpdateComponent } from './components/image-update/image-update.component';
import { AreaHeaderComponent } from './components/area-header/area-header.component';
import { ContainerSearchFieldComponent } from './components/container-search-field/container-search-field.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { UploadQueueOverlayComponent } from './components/upload-queue-overlay/upload-queue-overlay.component';
import { InputFormDialogComponent } from './components/input-form-modal/input-form-dialog.component';
import { SubscriptionsPageComponent } from './components/subscriptions-page/subscriptions-page.component';
import { SubscriptionsComponent } from './components/subscriptions-page/components/subscriptions/subscriptions.component';
import { ImageCanvasViewportComponent } from './image-canvas/image-canvas-viewport.component';
import { ChecksModalComponent } from './components/checks-modal/checks-modal.component';

@NgModule({
    declarations: [
        AreaHeaderComponent,
        ContainerSearchFieldComponent,
        ConfirmationDialogComponent,
        ConfirmDialogComponent,
        PaginationComponent,
        HeaderBoxComponent,
        DisplayErrorsComponent,
        WizardFormComponent,
        FloatingNumberInputComponent,
        LineChartComponent,
        CarouselComponent,
        InputPagingBarComponent,
        UserInfoComponent,
        ProjectOverviewLayoutComponent,
        NewLineToBrPipe,
        LocalizedDatePipe,
        ToastMessageContainerComponent,
        AlgorithmInputComponent,
        DropdownComponent,
        CheckboxComponent,
        ContainerImageUploadComponent,
        ContainerCollaborationSettingsComponent,
        SettingsComponent,
        ContainerMembersComponent,
        SimpleTrybPaginationComponent,
        ImageUpdateComponent,
        UploadQueueOverlayComponent,
        InputFormDialogComponent,
        SubscriptionsPageComponent,
        SubscriptionsComponent,
        ImageCanvasViewportComponent,
        ChecksModalComponent,
    ],
    imports: [
        CommonModule,
        SharedRoutingModule,
        MaterialModule,
        ReactiveFormsModule,
        NgbToastModule,
        TranslateModule,
        CarouselModule,
        FormsModule,
        NgbPaginationModule,
        ImageCropperComponent,
    ],
    exports: [
        AreaHeaderComponent,
        ContainerSearchFieldComponent,
        ConfirmationDialogComponent,
        PaginationComponent,
        HeaderBoxComponent,
        DisplayErrorsComponent,
        WizardFormComponent,
        FloatingNumberInputComponent,
        LineChartComponent,
        CarouselComponent,
        InputPagingBarComponent,
        UserInfoComponent,
        ProjectOverviewLayoutComponent,
        NewLineToBrPipe,
        LocalizedDatePipe,
        ToastMessageContainerComponent,
        //TODO: remove import of translate module from other modules that import sharedModule
        TranslateModule,
        AlgorithmInputComponent,
        DropdownComponent,
        CheckboxComponent,
        ContainerCollaborationSettingsComponent,
        SettingsComponent,
        ContainerMembersComponent,
        SimpleTrybPaginationComponent,
        ImageUpdateComponent,
        UploadQueueOverlayComponent,
        SubscriptionsPageComponent,
        ImageCanvasViewportComponent,
        ChecksModalComponent,
    ],
})
export class SharedModule {}
